import { isolateDirection } from "@frontend-shared/lib";
import type { IChatListObject } from "@frontend-shared/types";
import React from "react";
import { useTranslation } from "react-i18next";

import { ConfirmationDialog } from "@/components/ConfirmationDialog";

interface IArchiveChatDialogProps {
  chat: IChatListObject;
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  onArchive: () => void;
}

export const ArchiveChatDialog: React.FC<IArchiveChatDialogProps> = ({
  chat,
  isOpen,
  onOpenChange,
  onArchive,
}) => {
  const { t } = useTranslation("sidebar");
  const handleArchiveConfirm = () => {
    onArchive();
    onOpenChange(false);
  };

  return (
    <ConfirmationDialog
      open={isOpen}
      onOpenChange={onOpenChange}
      content={{
        title: t("chat_list.archive_chat.title", {
          title: isolateDirection(chat.title),
        }),
        description: t("chat_list.archive_chat.description"),
        cancelText: t("chat_list.archive_chat.cancel"),
        confirmText: t("chat_list.archive_chat.archive"),
      }}
      actions={{
        onConfirm: handleArchiveConfirm,
      }}
      testIdPrefix="archive-chat"
    />
  );
};
